<template>
  <div
    id="popover-target-1"
    class="userinfo-wrapper tw-flex tw-items-center tw-cursor-pointer tw-flex-none"
  >
    <img
      :src="userInfo?.avatar"
      style="width: 34px; height: 34px; border-radius: 18px; margin-right: 6px"
      alt
      @click="toPath('/controlCenter/personal-setting')"
    />
    <!-- <b-button variant="primary" size="sm">{{ userInfo.name }}</b-button> -->
    <div
      class="tw-text-sm"
      style="
        max-width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 8px;
      "
    >
      {{ userInfo?.name }}
    </div>
    <b-popover
      target="popover-target-1"
      triggers="hover"
      placement="top"
      :boundary-padding="0"
      delay="300"
      @show="onPopoverShow"
    >
      <template #title></template>
      <div class="popover-content">
        <div class="popover-top tw-flex tw-items-center">
          <img
            :src="userInfo?.avatar"
            style="width: 40px; height: 40px; border-radius: 50px"
            alt
          />
          <div class="tw-ml-2">
            <div
              class="tw-flex tw-items-center tw-space-x-2 tw-text-textInfo tw-text-sm"
            >
              <span>{{ userInfo?.name }}</span>
            </div>
            <div class="tw-text-xs tw-text-textDisabled" v-if="userInfo?.phone">
              <span>{{ userInfo?.phone }}</span>
            </div>
          </div>
        </div>
        <div
          v-if="false"
          class="popover-top tw-flex tw-items-center tw-justify-between"
        >
          <div>
            <span class="tw-text-textLight"> {{ $t("账户余额") }}：</span>
            <span class="tw-text-textMain">$3254.12</span>
          </div>
          <span
            class="tw-text-primary tw-underline tw-cursor-pointer"
            @click="toPath('/controlCenter/recharge')"
            >{{ $t("充值") }}</span
          >
        </div>

        <ul class="popover-pay">
          <li class="pay-list" @click="toPath('/controlCenter/my-order')">
            <span>{{ $t("待支付") }}</span>
            <span class="pay-num">{{ userInfo?.pendingPayCount }}</span>
          </li>
          <li
            class="pay-list"
            @click="toPath('/controlCenter/renewal-management')"
          >
            <span>{{ $t("待续费") }}</span>
            <span class="pay-num">{{ userInfo?.expiringIn7DaysCount }}</span>
          </li>
          <li
            class="pay-list"
            @click="toPath('/controlCenter/personal-setting')"
          >
            <span>{{ $t("未读公告") }}</span>
            <span class="pay-num">{{ userInfo?.unreadCount }}</span>
          </li>
        </ul>

        <ul class="popover-plan">
          <li
            class="plan-list tw-flex tw-items-center tw-justify-between"
            @click="toPath('/controlCenter/personal-setting')"
          >
            <div class="tw-flex tw-space-x-2">
              <img :src="personageImg" class="plan-img" alt />
              <span class="plan-text">{{ $t("个人中心") }}</span>
            </div>
            <i class="bi bi-chevron-right"></i>
          </li>
          <li
            class="plan-list tw-flex tw-items-center tw-justify-between"
            @click="toPath('/apiWord/api-console')"
          >
            <div class="tw-flex tw-space-x-2">
              <img :src="ApiImg" class="plan-img" alt />
              <span class="plan-text">{{ $t("BLOCKWATCH工作台") }}</span>
            </div>
            <i class="bi bi-chevron-right"></i>
          </li>
          <li
            class="plan-list tw-flex tw-items-center tw-justify-between"
            @click="toPath('/cloudWord/cloud-word')"
          >
            <div class="tw-flex tw-space-x-2">
              <img :src="cloudImg" class="plan-img" alt />
              <span class="plan-text">{{ $t("云服务工作台") }}</span>
            </div>
            <i class="bi bi-chevron-right"></i>
          </li>
        </ul>

        <div class="shortcut-wrap">
          <p class="shortcut">{{ $t("快捷入口") }}</p>
          <ul class="shortcut-list">
            <li
              class="shortcut-list-item"
              @click="toPath('/controlCenter/my-order')"
            >
              <span>{{ $t("我的订单") }}</span>
            </li>
            <li
              class="shortcut-list-item"
              @click="toPath('/controlCenter/coupon-management')"
            >
              <span>{{ $t("优惠券") }}</span>
            </li>
            <li
              class="shortcut-list-item"
              @click="toPath('/controlCenter/shopping-cart')"
            >
              <span>{{ $t("购物车") }}</span>
            </li>
          </ul>
          <div class="tw-flex tw-justify-center">
            <b-button variant="outline-danger" size="sm" @click="outLogin">
              {{ $t("退出登录") }}
            </b-button>
          </div>
        </div>
      </div>
    </b-popover>

  </div>
</template>

<script>
import ApiImg from "@/assets/user/Api.png";
import cloudImg from "@/assets/user/cloud.png";
import personageImg from "@/assets/user/personage.png";
import { getUserInfoApi } from "@/api/modules/home";
import { goToBlockWatch, goToOfficialWebsite } from "@/utils/domain";
import { clearAuthStorage, isJwtExpired } from "@/utils/auth-token";
export default {
  name: "UserInfo",
  data() {
    return {
      ApiImg,
      cloudImg,
      personageImg,
      userInfo: {},
    };
  },
  computed: {
    isVerification() {
      return this.$store.state.isVerification;
    },
  },
  created() {
    this.syncAuthState();
  },
  methods: {
    syncAuthState() {
      const token = localStorage.getItem("token");
      if (!token || isJwtExpired(token)) {
        clearAuthStorage("expired");
        this.userInfo = {};
        return false;
      }

      try {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      } catch (error) {
        this.userInfo = {};
        localStorage.removeItem("userInfo");
      }
      return true;
    },
    // 跳转路由
    toPath(path) {
      // this.$store.commit("SET_VERIFICATION", "0");
      const redirectUrl = localStorage.getItem("redirectUrl");
      if (redirectUrl) {
        localStorage.removeItem("redirectUrl");
      }
      if (path === "/apiWord/api-console" && this.isVerification === "0") {
        this.$emit("open-api-auth");
        return;
      }
      if (path === "/apiWord/api-console") {
        goToBlockWatch(path);
      } else {
        goToOfficialWebsite(path);
      }
    },

    // 监听
    onPopoverShow() {
      this.getUser();
    },
    // 获取用户信息
    async getUser() {
      if (!this.syncAuthState()) return;

      try {
        const { code, data } = await getUserInfoApi();
        if (code !== 0) return;
        this.userInfo = data;
        localStorage.setItem("userInfo", JSON.stringify(data));
      } catch (error) {
        this.syncAuthState();
      }
    },
    // 退出登录
    outLogin() {
      this.$emit("outLogin");
    },
  },
};
</script>

<style lang="scss" scoped>
.b-popover {
  width: 271px !important;
  top: 20px !important;
  left: -10px !important;
  border: none !important;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.08) !important;
  z-index: 99999;
}
::v-deep .popover-body {
  padding: 0 !important;
}
::v-deep .arrow::before {
  border-bottom-color: transparent !important;
}
::v-deep .arrow::after {
  border-width: 0 !important;
}
.popover-eye {
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
}
.popover-top {
  padding: 16px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #ebebeb;
}
.popover-pay {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid #ebebeb;
}
.pay-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  cursor: pointer;
}
.pay-num {
  color: #4077f8;
}
.popover-plan {
  padding: 0 0 10px 0;
  border-bottom: 1px solid #ebebeb;
}
.plan-list {
  padding: 10px 20px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
}

.plan-img {
  width: 20px;
  height: 20px;
}

.shortcut-wrap {
  padding: 10px 30px;
}
.shortcut {
  position: relative;
  font-size: 14px;
  color: #4077f8;
  &::before {
    content: "";
    position: absolute;
    left: -10px;
    top: 2px;
    bottom: 2px;
    width: 2px;
    background-color: #4077f8;
  }
}
.shortcut-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0 0 20px 0;
}
.shortcut-list-item {
  position: relative;
  padding-left: 16px;
  cursor: pointer;
  &:hover {
    color: #4077f8;
  }

  /* 每个元素都显示小圆点 */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 3px;
    bottom: 3px;
    width: 4px;
    background-color: #ebebeb;
  }
}

.shortcut-list-item:first-child {
  padding-left: 0px;
}
.shortcut-list-item:first-child::before {
  content: none;
}
</style>
